<template>
  <div class="hello" id="hello">
    <div class="myTip" v-if="signInTipShow">
      <van-icon name="checked" size="24" :color="themeRGBColor"/>
      <div style="width: 15px;"></div>
      <span :style='"font-size: 14px;color:" + themeRGBColor'>签到成功 + {{
          signInTipNum
        }} {{ contributionRealName }}</span>
    </div>
    <div class="contentOutside">
      <van-notice-bar left-icon="volume-o" :text="noticeContent" mode="closeable" v-if="noticeShow"
                      @close="closeNotice" :background="themeRGBAColor" :color="themeRGBColor"/>
      <div class="wrapColour">
        <img class="logo" :src="userInformation.avatarUrl" alt=""/>
        <div class="wrap">
          <div class="wrapCon">
            <div class="dividends" @click="dividends" :style="{ color: dynamicColor.rgb }">
              <countTos startNum="0" class="dividendsNum" :endNum="Number.parseFloat(userInformation.bonus.toFixed(5))"
                        speed="80" times="10"></countTos>
              <span class="dividendsTxt">{{ bonusRealName }}></span>
            </div>
            <div class="contribution" @click="contributeBut">
              <span v-if="userInformation">{{
                  userInformation.contribution
                }}</span>
              <span>{{ contributionRealName }}></span>
            </div>
          </div>
          <div class="navigation">
            <div class="raidersWrap" @click="raidersCli">
              <img class="raiders" src="../../static/images/Raiders.png" alt=""/>
              <p>攻略</p>
            </div>
            <div class="raidersWrap" @click="home"  v-if="homeSwitch != 'false'">
              <img alt="" class="home" src="../../static/images/home.png"/>
              <p>首页</p>
            </div>
          </div>
        </div>
      </div>
      <div class="PlanetWrap" v-if="!figureShow">
        <img v-if="bigSwitch" class="change" @click.stop="change" src="../../static/images/change.png" alt="">
        <div class="prompt" v-if="popUpsStat">
          <div style="height: 100%;width: 100%; position: relative">
            <div class="promptTxt">{{ sessionShow }}</div>
          </div>
          <img class="arrow" src="../../static/images/triangle.png" alt=""/>
        </div>
        <Meteor class="meteorSvg"></Meteor>
        <div class="planetModule">
          <div v-if="PlanetStat" class="Planet">
            <router-view :plantBackgroundImage="plantBackgroundImage" :plantBackgroundOpacity="plantBackgroundOpacity"></router-view>
          </div>
          <div class="PlanetFileWrap" @click.stop="planet"></div>
          <div v-for="(item, index) in nodeList" v-if="item.stat" :key="index" :class="
            index === nodeSubscript || item.isAnimationStart
              ? item.className + ' dots'
              : item.className + ' dynamicHaloWrap-float'
          " class="dynamicHaloWrap"
               @click="dynamicHalo(index, item.value, item.index, item.timeStamp)">
            <bigBlueDot :themeBonusIcon="themeBonusIcon" class="dynamicHalo points"></bigBlueDot>
            <p>{{ item.value }}</p>
            <p v-if="currentTimeStamp >= item.timeStamp" style="font-weight: 500" :style="{ color: dynamicColor.rgb }">
              即将过期
            </p>
          </div>
          <div class="count-down" style="display: flex;justify-content: center;align-items: center;font-size: 15px;">
            <div style="position: relative">
              <div style="width: 60px">
                <van-count-down :time="countDownTime">

                </van-count-down>
              </div>
              <div class="question-container">
                <van-popover
                  v-model="showTipShowcountDown"
                  trigger="click"
                  placement="top"
                >
                  <div style="padding: 10px;">距下一次发放{{ bonusRealName }}剩余时间</div>
                  <template #reference>
                    <img class="question" style="width: 15px;height: 15px;"
                         src="../../static/images/question.png"/>
                  </template>
                </van-popover>
              </div>
            </div>
            <div @click="oneClickCollect" class="yjlq" style="border: 1px solid #cccccc;">一键领取</div>
          </div>
          <div class="statistics">
            <p class="statistics_p1">
              已有{{ platformContribution.peopleNum }}成员参与分配
            </p>
            <div class="progressBar">
              <p class="ProgressBarBackground" :style="{ background: dynamicColor.rgba }"></p>
              <div class="carryOut" :style="{ width: platformContribution.percent + '%' }">
                <p class="degreeOfCompletion" :style="{ background: dynamicColor.rgb }"></p>
                <div class="carryOutImg" :style="{ background: dynamicColor.rgba }">
                  <p :style="{ background: dynamicColor.rgb }"></p>
                </div>
                <!--                <img class="carryOutImg" src="/static/images/item1.png" alt="">-->
              </div>
            </div>
            <p class="statistics_p2" :style="{ color: dynamicColor.rgb }">
              我的{{ contributionRealName }}超过{{
                platformContribution.percent
              }}%成员
            </p>
          </div>
        </div>
      </div>
      <div v-if="bigSwitch" :class="(figureShow &&　smallSwitch)　? 'big-switch' : ''">
        <div class="statistic" v-if="figureShow">
          <img class="change" @click.stop="change" src="../../static/images/change.png" alt="">
          <statistics :bonusRealName="bonusRealName" :contributionRealName="contributionRealName"
                      :themeRGBColor="themeRGBColor" :themeRGBAColor="themeRGBAColor"
                      :themeRGBGradient="themeRGBGradient" :xaxis7Days="xaxis7Days"
                      :yaxis7Days="yaxis7Days" :xaxis30Days="xaxis30Days"
                      :yaxis30Days="yaxis30Days" :xaxisAllDays="xaxisAllDays"
                      :yaxisAllDays="yaxisAllDays"></statistics>
        </div>
        <div v-if="smallSwitch">
          <div class="scoreData" v-if="figureShow">
            <div class="rate">{{ bonusRealName }}发放数据</div>

            <div class="data">
              <div class="detail">
                <div class="subtitle" :style='"color: " + themeRGBColor'>昨日</div>
                <div :style="'font-size:20px;font-weight:600;color:' + themeRGBColor">{{
                    Math.floor(totalBonusYesterday)
                  }}
                </div>
              </div>
              <div class="gap"></div>
              <div class="detail">
                <div class="subtitle" :style='"color: " + themeRGBColor'>历史累计</div>
                <div :style="'font-size:20px;font-weight:600;color:' + themeRGBColor">{{
                    Math.floor(totalBonusAll)
                  }}
                </div>
              </div>
              <div class="gap"></div>
              <div class="detail">
                <div class="subtitle" style="display:flex;align-items:center;">
                  <div style="display: flex;align-items: center;">
                    <span :style='"color: " + themeRGBColor'>近一年预估</span>
                    <!--                    <img class="question1" style="width: 14px;height: 14px;"-->
                    <!--                         src="../../static/images/question.png"/>-->
                    <div class="flex-c">
                      <van-popover
                        v-model="showTipOneYear"
                        trigger="click"
                        placement="left"
                      >
                        <div style="padding: 10px;width: 160px;">
                          依据最近90天日均{{
                            bonusRealName
                          }}数据，对近1年将发放的{{
                            bonusRealName
                          }}数量进行动态预估（每天更新1次）
                        </div>
                        <template #reference>
                          <div style="height: 100%" class="flex-c">
                            <img class="question1" style="width: 14px;height: 14px;"
                                 src="../../static/images/question.png"/>
                          </div>
                        </template>
                      </van-popover>
                    </div>
                  </div>
                </div>
                <div :style="'font-size:20px;font-weight:600;color:' + themeRGBColor">{{
                    Math.floor(totalBonusEstimate)
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="wave">
        <div class="wrapImg">
          <img class="waves" src="../../static/images/_11.gif" alt=""/>
        </div>
      </div>
      <div class="tab">
        <div :class="tabNum == 0 ? 'on' : ''" @click="tab(0)">
          <span style="font-size: 21px;">{{ contributionRealName }}任务</span>
          <div :style="{ background: dynamicColor.rgb }"></div>
        </div>
        <div :class="tabNum == 1 ? 'on' : ''" @click="tab(1)">
          <span style="font-size: 21px;">{{ bonusRealName }}排行</span>
          <div :style="{ background: dynamicColor.rgb }"></div>
        </div>
      </div>
      <div class="operatingWrap" v-show="tabNum == 0">
        <Notice :themeRGBAColor="themeRGBAColor" :themeRGBColor="themeRGBColor" :message="contributionList"></Notice>
      </div>
      <div class="ulsList">
        <div v-if="tabNum == 0">
          <!--          <div class="dailyCheckIn" v-if="signInStat">-->
          <!--            <p>每日签到</p>-->
          <!--            <p @click="signIn" :style="{background:dynamicColor.rgb}">签到</p>-->
          <!--          </div>-->
          <div class="taskType" v-for="(item, index) in contributionTask" :key="index">

            <div class="dailyCheckIn" v-if="item.key == '每日签到'">
              <p style="font-size: 21px;">每日签到</p>
              <p @click="signIn(item)" v-if="item.list[0].isFinished == 0"
                 :style='"background:" + dynamicColor.rgb + ";text-align:center;"'>
                签到</p>
              <p v-if="item.list[0].isFinished == 1" style="color: #878787;">已完成</p>
            </div>

            <div v-else>
              <!--              <h3>{{ item.key }}</h3>-->
              <p style="font-size: 21px;padding: 20px 0px 0px 20px;font-weight: 600;">{{ item.key }}</p>
              <ul class="ulsList_">
                <!--              <li v-for="(e,x) in item.list" v-if="e.name != '签到'">-->
                <li v-for="(e, x) in item.list" :key="x">
                  <div>
                    <p>
                      {{ e.name }}
                      <span v-if="e.isTarget == 1">({{ e.currentTarget }}/{{ e.target }})</span>
                    </p>
                    <p>
                    <span :style="{ color: dynamicColor.rgb }">{{
                        e.contribution
                      }}</span>
                      <span>{{ contributionRealName }}&nbsp;</span>
                      <span v-if="e.isLimit == 1" :style="{ color: dynamicColor.rgb }">限时:{{
                          e.limitStart | timeFilter
                        }}
                      至
                      {{ e.limitEnd | timeFilter }}</span>
                    </p>
                  </div>
                  <div v-if="e.isTarget == 0">
                    <p @click="toFinish(e)" :class="e.status == 1 ? 'ButOn' : ''"
                       :style="{ color: dynamicColor.rgb, border: borderColor }">
                      {{ e.buttonText }}
                    </p>
                  </div>
                  <div v-else>
                    <p @click="toFinish(e)" :class="e.status == 1 ? 'ButOn' : ''"
                       :style="{ color: dynamicColor.rgb, border: borderColor }" v-if="e.isFinished == 0">
                      {{ e.buttonText }}
                    </p>
                    <p @click="toFinish(e)" :class="e.status == 1 ? 'ButFinishOn' : ''" v-else>
                      {{ e.finishButtonText }}
                    </p>
                  </div>
                </li>
              </ul>
            </div>


          </div>
        </div>
        <div v-if="tabNum == 1">
          <div class="statTab" :style="{ marginBottom: statTab != 0 ? '15px' : '0' }">
            <p class="statTabOn" :style="
              statTab == 1
                ? { color: dynamicColor.rgb, background: dynamicColor.rgba }
                : {}
            " @click="statTabs(1)">
              总榜
            </p>
            <p class="statTabOn" :style="
              statTab == 2
                ? { color: dynamicColor.rgb, background: dynamicColor.rgba }
                : {}
            " @click="statTabs(2)">
              周榜
            </p>
            <p class="statTabOn" :style="
              statTab == 3
                ? { color: dynamicColor.rgb, background: dynamicColor.rgba }
                : {}
            " @click="statTabs(3)">
              成长榜
            </p>
          </div>
          <div class="rank" v-if="statTab == 1">
            <p>我的排名{{ dividendRankingList.myRank }}</p>
            <p>
              较昨日
              <!--              <span :style="{color:dividendRankingList.upDown==1?'#2f80ed':'#878787'}">↓{{ dividendRankingList.upDownRank }}名</span>-->
              <span :style="{ color: dynamicColor.rgb }" v-if="dividendRankingList.upDown == 1">↓{{
                  dividendRankingList.upDownRank
                }}名</span>
              <span :style="{ color: dynamicColor.rgb }" v-else>↑{{ dividendRankingList.upDownRank }}名</span>
            </p>
          </div>
          <ul class="uls" v-if="dividendRankingList.list.length != 0">
            <li class="rankingList" v-for="(item, index) in dividendRankingList.list" :key="index">
              <div class="rankingListCon">
                <img :src="item.avatarUrl" alt=""/>
                <div class="rankingListConTitle">
                  <h3 :style="{
                    fontWeight: index >= 3 ? '500' : '',
                    fontFamily: index < 3 ? 'FZCYJ' : '',
                  }">
                    No.{{ item.no }}
                  </h3>
                  <p>{{ item.nickName }}</p>
                </div>
                <div class="rankingListConTitle_" style="width: 120px">
                  <p :style="{ color: dynamicColor.rgb }">
                    <span v-if="statTab == 3" :style="{ color: dynamicColor.rgb }">↑</span>
                    {{
                      statTab == 3
                        ? ((item.rate - 1) * 100).toFixed(2) + "%"
                        : item.totalBonus.toFixed(1)
                    }}
                  </p>
                  <p>{{ contributionRealName }}{{ Math.floor(item.totalContribution) }}</p>
                </div>
              </div>
            </li>
          </ul>
          <div v-if="dividendRankingList.list.length == 0" class="noData">
            <img alt="" src="../../static/images/empty.png"/>
            <p>暂无数据</p>
          </div>
        </div>
        <div class="bottom">
          <div class="bottom-logo">
            <img alt="" src="../../static/images/Vector.svg"/>
            <span> 提供技术支持</span>
          </div>
          <p>
            <van-icon name="edit" @click="suggestCli"/>
            <span @click="suggestCli">需求与建议></span>
          </p>
        </div>
      </div>
      <div v-if="popStat" class="pop">
        <popUps :popStats="popStat_"></popUps>
      </div>
    </div>
    <div></div>
    <van-popup
      v-model="popupShow"
      round
      position="bottom"
      :close-on-click-overlay="false"
      :style="{ height: '30%' }"
    >
      <div style="padding: 20px">
        <van-cell-group>
          <van-field
            required
            v-model="mobile"
            type="tel"
            label="手机号："
            placeholder="请输入手机号"
          />
        </van-cell-group>
        <div style="height: 20px"></div>
        <van-button type="primary" @click="login" block>登录应用</van-button>
      </div>
    </van-popup>
    <van-notify v-model="show" type="danger">
      <van-icon name="bell" style="margin-right: 4px"/>
      <span>{{ msg }}</span>
    </van-notify>
  </div>
</template>


<script>
import SVGA from "svgaplayerweb";
import countIn from "@/component/digitalScroll/index";
import popUps from "@/component/popUps/index";
import Wave from "@/component/wave/index"; // 波浪
import Meteor from "@/component/meteor/index"; // 流星
import Notice from "@/component/notice/index"; //滚动公告栏
import singleColorDot from "@/component/singleColorDot/index"; //小兰点
import singleColorDotB from "@/component/singleColorDotA/index"; //小兰点b
import singleColorDotC from "@/component/singleColorDotB/index"; //小兰点b
import bigBlueDot from "@/component/bigBlueDot/index"; //大兰点
import bigBlueDotA from "@/component/bigBlueDotA/index"; //大兰点
import bigBlueDotB from "@/component/bigBlueDotB/index"; //大兰点
import PlanetFile from "@/component/planetsFile/index"; //星球
import {getUrlKey} from "../request/getUrlKey.js";
import {Toast} from "vant";
import countTo from "vue-count-to";
import countTos from "@/component/countTos/index";
import statistics from "@/component/line/line";
import {Loading} from "element-ui";
import {inWeixin} from "@/utils/util";
import cookie from "js-cookie";

// var appid = localStorage.getItem("xq-appid");
// var mobile = localStorage.getItem("xq-mobile");
var mobile = cookie.get("xq-mobile");
var appid = cookie.get("xq-appid");


export default {
  name: "HelloWorld",
  components: {
    countIn,
    popUps,
    Toast,
    Wave,
    Meteor,
    Notice,
    singleColorDot,
    singleColorDotB,
    singleColorDotC,
    bigBlueDot,
    bigBlueDotA,
    bigBlueDotB,
    PlanetFile,
    countTo,
    countTos,
    statistics
  },
  data() {
    return {
      nums_: "3.56114",
      apiName: {}, //接口集合定义
      popUpsStat: false,
      bonusRealName: "分红",
      contributionRealName: "贡献",
      tabNum: 0,
      statTab: 1,
      scrollNum: 1,
      nodeSubscript: false,
      popStat: true,
      userInformation: {bonus: 0.0}, //用户信息
      decimal: 0, //获取小数后面的长度
      nodeList: [],
      classLsist: [
        "dynamicHalo_a",
        "dynamicHalo_b",
        "dynamicHalo_c",
        "dynamicHalo_d",
        "dynamicHalo_e",
        "dynamicHalo_f",
        "dynamicHalo_g",
        "dynamicHalo_h",
        "dynamicHalo_i",
        "dynamicHalo_j",
        "dynamicHalo_k",
        "dynamicHalo_l",
        "dynamicHalo_m",
      ],
      planetArr: [], //获取每次选中的蓝点坐标
      contributionList: [], //贡献公告栏
      dividendRankingList: {
        list: [],
        myRank: "",
        upDown: 0,
        upDownRank: null
      },
      platformContribution: {},
      contributionTask: [], //贡献任务列表
      popStat_: {},
      dynamicColor: {},
      themeRGBColor: '',
      themeRGBAColor: '',
      themeRGBGradient: '',
      themeBonusIcon: '',
      plantBackgroundImage: '',
      plantBackgroundOpacity: 1,
      homeSwitch: 'true',
      copyrightShow: 1,
      homeUrl: "",
      borderColor: "",
      signInStat: true,
      len: 0,
      PlanetStat: false,
      currentTimeStamp: 0,
      popupShow: false,
      show: false,
      figureShow: false,
      tipShow: false,
      bigSwitch: true,
      smallSwitch: true,
      session: [],
      sessionShow: '',
      noticeContent: '',
      noticeShow: '',
      isReceiving: false,
      totalBonusYesterday: '',
      totalBonusAll: '',
      totalBonusEstimate: '',
      xaxis7Days: [],
      yaxis7Days: [],
      xaxis30Days: [],
      yaxis30Days: [],
      xaxisAllDays: [],
      yaxisAllDays: [],
      countDownTime: 30 * 60 * 60 * 1000,
      showTipShowcountDown: false,
      showTipOneYear: false,
      figureShowInit: false,
      signInTipNum: 0,
      signInTipShow: false
    };
  },

  updated() {
    if (this.$store.state.stat == 1) {
      setTimeout(() => {
        document.documentElement.scrollTop = 500;
      }, 100);
      this.$forceUpdate();

      this.$store.state.stat = 0;
    }
  },
  async created() {
    var mobile = cookie.get("xq-mobile");
    var appid = cookie.get("xq-appid");
    // var mobile = localStorage.getItem("xq-mobile");
    // var appid = localStorage.getItem("xq-appid");
    if (mobile == undefined || appid == undefined) {
      this.popupShow = true;
      return;
    }
    this.currentTimeStamp = new Date().getTime();
    if (await this.getLocalStoreItem("pageStat") != 1) {
      this.setLocalStoreItem("pageStat", 1);
      this.$router.go(0);
      this.dataset();
    } else {
      this.dataset();
    }
  },
  filters: {
    timeFilter(timeStr) {
      return timeStr.substring(5, 10);
    },
  },
  watch: {
    xaxis7Days: {
      handler(val) {
        this.figureShow = this.figureShowInit;
      },
      deep: true
    }
  },
  methods: {
    oneClickCollect(){
      let data = [];
      for (let i = 0; i < this.nodeList.length; i++) {
        let item1 = this.nodeList[i];
        if(!item1.recved){
          item1.isAnimationStart = true
          data.push({
            token: this.$store.state.parameterUrl,
            bonus: item1.value,
            index: item1.index,
          })
        }
      }
      let ps = [];
      let promise = this.$post(this.apiName.receiveBatch, data).then((res) => {
        if (res.code != "0000") {
          Toast.fail(res.msg);
        }
      }).catch((res) => {
        Toast.fail("网络错误");
      });
      ps.push(promise)
      Promise.all(ps).then(() => {
        this.nodeSubscript = false
        this.dataset()
      });
    },
    onTimeChange(e) {
      console.log(e)
      this.timeData = e.detail;
    },
    tipShowcountDown() {
      alert("据下一次积分发放剩余时间");
    },
    tipShowMethod() {
      alert("根据历史日均积分数据对近1年将发放的积分数量的动态预估");
    },
    change() {
      this.figureShow = !this.figureShow
    },
    getQueryObject(url) {
      const requestStr = location.search.slice(1);
      const requestArray = requestStr.split("&");
      const obj = {};
      requestArray.forEach((item) => {
        const index = item.indexOf("=");
        const key = item.slice(0, index);
        const value = item.slice(index + 1);
        obj[key] = value;
      });
      return obj;
    },
    login() {
      this.$post(this.API1url.API.verifyMobile, {
        shopid: this.getQueryObject().shopid,
        mobile: this.mobile,
      }).then((res) => {
        // console.log(res)
        if (res.code == 0) {
          cookie.set("xq-mobile", this.mobile);
          cookie.set("xq-appid", res.data);
          // localStorage.setItem("xq-mobile", this.mobile)
          // localStorage.setItem("xq-appid", res.data)
          this.popupShow = false;
          var apiName = this.API1url.API;
          this.$get(apiName.Color, {
            appid: res.data,
            mobile: this.mobile,
          })
            .then((res) => {
              if (res.code == "0000") {
                // console.log(res)
                // res.data.rgb = 'rgb(253, 1, 66)'   961d361e97db42178b459c3eac7380da
                // res.data.rgba = 'rgba(253, 1, 66,.2)'
                this.setLocalStoreItem("bakColor", JSON.stringify(res.data));
                // this.$router.go(0);
                window.location.reload();
              }
            })
            .catch((res) => {
              Toast.fail("加载失败");
            });
        } else {
          this.show = true;
          this.msg = res.msg;
          setTimeout(() => {
            this.show = false;
          }, 2000);
        }
      });
      // localStorage.setItem("xq-mobile", this.mobile);
    },
    dataset() {
      var loadingInstance = Loading.service();
      setTimeout(() => {
        var apiName = this.API1url.API;
        this.$get(apiName.Color, {
          appid: appid,
          mobile: mobile,
        })
          .then(async(res) => {
            if (res.code == "0000") {
              var str = res.data;
              this.themeRGBColor = str.rgb;
              this.themeRGBGradient = str.rgbGradient;
              this.themeRGBAColor = str.rgba;
              this.themeBonusIcon = str.bonusIcon;
              if(str.plantBackgroundImage){
                this.plantBackgroundImage = this.$getBaseUrl() + '/static' + str.plantBackgroundImage;
              }
              if(str.plantBackgroundOpacity != null && str.plantBackgroundOpacity != ''){
                this.plantBackgroundOpacity = Number(str.plantBackgroundOpacity) / 100;
              }
              this.homeSwitch = str.homeSwitch;
              this.copyrightShow = str.copyrightShow;
              this.$forceUpdate();
              // alert(123)
              this.PlanetStat = true;
              this.setLocalStoreItem("bakColor", JSON.stringify(res.data));
              this.borderColor = "1px solid " + str.rgb;
              this.dynamicColor = JSON.parse(await this.getLocalStoreItem("bakColor"));
            }
          })
          .catch((res) => {
            Toast.fail("加载失败");
          });
        this.apiName = this.API1url.API;
        this.$get(this.apiName.realNameData, {
          // 获取分红、贡献真名
          appid: appid,
          mobile: mobile,
        }).then((res) => {
          if (res.code == "0000") {
            this.bonusRealName =
              res.data.bonusRealName != null ? res.data.bonusRealName : "分红";
            this.contributionRealName =
              res.data.contributionRealName != null
                ? res.data.contributionRealName
                : "贡献";
          } else {
            Toast.fail("加载失败");
          }
        });

        this.$get(this.apiName.trend, {
          // 获取趋势图显隐
          appid: appid,
          mobile: mobile,
        }).then((res) => {
          if (res.code == "0000") {
            this.bigSwitch = res.data.bigSwitch == "1" ? true : false
            this.smallSwitch = res.data.smallSwitch == "1" ? true : false

            this.$get(this.apiName.indexList, {
              //星球中的小兰点
              appid: appid,
              mobile: mobile,
            }).then((res) => {
              if (res.code == "0000") {
                // console.log(res)
                var timestamp = new Date().getTime();
                var arr = [];
                if (res.data == null || res.data.length == 0) {
                  if (!this.bigSwitch) {
                    this.figureShowInit = false;
                  } else {
                    this.figureShowInit = true;
                  }
                }
                res.data.forEach((item, index) => {
                  arr.push({
                    value: item.value,
                    timeStamp: item.timeStamp,
                    index: item.index,
                    className: this.classLsist[index],
                    stat: true,
                    endTiem: item.timeStamp - 12 * 60 * 60,
                    startTiem: Number(
                      Math.round(new Date().getTime() / 1000).toString()
                    ),
                    isAnimationStart: false,
                    recved: false
                  });
                });
                this.nodeList = arr;

                this.$get('data/yz/topStatistics', {
                  appid: appid,
                  mobile: mobile,
                }).then((res) => {
                  if (res.code == "0000") {
                    this.xaxis7Days = res.data.xaxis7Days;
                    this.yaxis7Days = res.data.yaxis7Days;
                    this.xaxis30Days = res.data.xaxis30Days;
                    this.yaxis30Days = res.data.yaxis30Days;
                    this.xaxisAllDays = res.data.xaxisAllDays;
                    this.yaxisAllDays = res.data.yaxisAllDays;
                    this.totalBonusYesterday = res.data.totalBonusYesterday;
                    this.totalBonusAll = res.data.totalBonusAll;
                    this.totalBonusEstimate = Math.floor(res.data.totalBonusEstimate);
                  } else {
                    Toast.fail("加载失败");
                  }
                });

              } else {
                Toast.fail("加载失败");
              }
            });
          } else {
            Toast.fail("加载失败");
          }
        });


        this.$get(this.apiName.session, {
          // 获取会话内容
          appid: appid,
          mobile: mobile,
        }).then((res) => {
          if (res.code == "0000") {
            this.session = res.data
          } else {
            Toast.fail("加载失败");
          }
        });

        this.$get(this.apiName.notice, {
          // 获取公告
          appid: appid,
          mobile: mobile,
        }).then(async(res) => {
          if (res.code == "0000") {
            this.noticeContent = res.data.noticeContent;
            var noticeContentStorage = await this.getLocalStoreItem("noticeContent");
            var shutdownStorage = await this.getLocalStoreItem("shutdown notice");
            if (noticeContentStorage) {
              if (noticeContentStorage != this.noticeContent) {
                this.removeLocalStoreItem("shutdown notice");
                this.setLocalStoreItem("noticeContent", this.noticeContent);
                this.noticeShow = res.data.noticeIsOn == '1' ? true : false
              } else {
                if (shutdownStorage) {
                  if (shutdownStorage == '1') {
                    this.noticeShow = false;
                  }
                } else {
                  this.noticeShow = res.data.noticeIsOn == '1' ? true : false
                }
              }
            } else {
              this.setLocalStoreItem("noticeContent", this.noticeContent);
              this.noticeShow = res.data.noticeIsOn == '1' ? true : false
            }
          } else {
            Toast.fail("加载失败");
          }
        });

        this.$get(this.apiName.homeUrl, {
          // 获取首页地址
          appid: appid,
          mobile: mobile,
        }).then((res) => {
          if (res.code == "0000") {
            this.homeUrl = res.data.homeUrl;
          } else {
            Toast.fail("加载失败");
          }
        });

        this.$get(this.apiName.information, {
          //获取用户信息
          appid: appid,
          mobile: mobile,
        }).then((res) => {
          if (res.code == "0000") {
            // alert(2)
            loadingInstance.close();
            // console.log(res.data.bonus.toString().indexOf('.')!=-1)
            if (res.data.bonus.toString().indexOf(".") != -1) {
              var len = res.data.bonus.toString().split(".");
              this.decimal = len.length == 2 ? len[1].length : 0;

              this.len = String(res.data.bonus).split(".")[1].length;
              // console.log(len)
              this.$store.state.userData = res.data;
              this.setLocalStoreItem("userData", JSON.stringify(res.data));
            }

            this.userInformation = res.data;
            var n = this.userInformation.bonus;
            if (n.toString().split(".")[1].length > 5) {
              this.userInformation.bonus = n.toFixed(5);
            }
          } else {
            Toast.fail("加载失败");
          }
        });
        this.$get(this.apiName.contributionRanking, {
          //平台贡献人数和超过多少人
          appid: appid,
          mobile: mobile,
        }).then((res) => {
          if (res.code == "0000") {
            console.log(res)
            this.platformContribution = res.data;
            this.countDownTime = res.data.timeStamp;
          } else {
            Toast.fail("加载失败");
          }
        });


        this.$get(this.apiName.contributionAnnouncement, {
          //用户贡献列表
          appid: appid,
          mobile: mobile,
        }).then((res) => {
          if (res.code == "0000") {
            this.contributionList = res.data || [];
          } else {
            Toast.fail("加载失败");
          }
        });
        this.$get(this.apiName.taskList, {
          //用户贡献任务列表
          appid: appid,
          mobile: mobile,
        }).then((res) => {
          if (res.code == "0000") {
            var str = res.data;
            var arr = [];
            var map = {};

            for (var i = 0; i < str.length; i++) {
              var ai = str[i];
              if (ai.name == "签到") {
                this.signInStat = ai.status == 1 ? false : true;
              }
              if (!map[ai.type]) {
                arr.push({
                  key: ai.type,
                  list: [ai],
                });
                map[ai.type] = ai;
              } else {
                for (var j = 0; j < arr.length; j++) {
                  var dj = arr[j];
                  if (dj.key == ai.type) {
                    dj.list.push(ai);
                    break;
                  }
                }
              }
            }
            this.contributionTask = arr;
          } else {
            Toast.fail("加载失败");
          }
        });
        this.dividendRankingData(1);
      }, 50);
    },
    signIn(obj) {
      if (obj.list[0].signInMode == 1) {
        // API签到模式
        this.toFinish(obj.list[0]);

      } else {
        let that = this
        // 自带签到
        this.$post(this.apiName.submit, {
          mobile: mobile,
          requestId: new Date().getTime().toString(),
          appId: '10000',
          list: [
            {
              no: '1',
              status: 1,
              type: 37,
              openId: '1',
              attach: ''
            }
          ],
          sign: "123456"
        }).then((res) => {
          if (res.code == "0000") {
            this.signInTipNum = Math.floor(Number(obj.list[0].contribution));
            this.signInTipShow = true;
            setTimeout(() => {
              this.signInTipShow = false;
            }, 3000);

            this.$get(this.apiName.taskList, {
              //用户贡献任务列表
              appid: appid,
              mobile: mobile
            }).then((res) => {
              if (res.code == "0000") {
                var str = res.data;
                var arr = [];
                var map = {};

                for (var i = 0; i < str.length; i++) {
                  var ai = str[i];
                  if (ai.name == "签到") {
                    this.signInStat = ai.status == 1 ? false : true;
                  }
                  if (!map[ai.type]) {
                    arr.push({
                      key: ai.type,
                      list: [ai],
                    });
                    map[ai.type] = ai;
                  } else {
                    for (var j = 0; j < arr.length; j++) {
                      var dj = arr[j];
                      if (dj.key == ai.type) {
                        dj.list.push(ai);
                        break;
                      }
                    }
                  }
                }
                this.contributionTask = arr;
              } else {
                Toast.fail("加载失败");
              }
            });
            this.$get(this.apiName.information, {
              //获取用户信息
              appid: appid,
              mobile: mobile,
            }).then((res) => {
              if (res.code == "0000") {
                // alert(2)
                loadingInstance.close();
                // console.log(res.data.bonus.toString().indexOf('.')!=-1)
                if (res.data.bonus.toString().indexOf(".") != -1) {
                  var len = res.data.bonus.toString().split(".");
                  this.decimal = len.length == 2 ? len[1].length : 0;

                  this.len = String(res.data.bonus).split(".")[1].length;
                  // console.log(len)
                  this.$store.state.userData = res.data;
                  this.setLocalStoreItem("userData", JSON.stringify(res.data));
                }

                this.userInformation = res.data;
                var n = this.userInformation.bonus;
                if (n.toString().split(".")[1].length > 5) {
                  this.userInformation.bonus = n.toFixed(5);
                }
              } else {
                Toast.fail("加载失败");
              }
            });

          }
        });
      }
    },
    planet() {
      if (!this.popUpsStat) {
        if (this.session.length > 2) {
          var index = Math.floor(Math.random() * (this.session.length - 1 - 0)) + 0;
          this.sessionShow = this.session[index];
          this.popUpsStat = true;
          this.popUpsHide();
        }
        if (this.session.length == 2) {
          if (Math.random() > 0.5) {
            this.sessionShow = this.session[1];
            this.popUpsStat = true;
            this.popUpsHide();
          } else {
            this.sessionShow = this.session[0];
            this.popUpsStat = true;
            this.popUpsHide();
          }
        }
        if (this.session.length == 1) {
          this.sessionShow = this.session[0];
          this.popUpsStat = true;
          this.popUpsHide();
        }
      }
    },
    popUpsHide() {
      setTimeout(() => {
        this.popUpsStat = false;
      }, 2000);
    },
    tab(e) {
      this.tabNum = e;
    },
    statTabs(e) {
      // console.log(e,"????")
      this.statTab = e;
      this.dividendRankingData(e);
    },
    dynamicHalo(e, x, y, time) {
      //点击蓝点上偏移
      let that = this;

      if (this.isReceiving) {
        //Toast.fail("请勿操作过快");
      } else {
        this.isReceiving = true;
        this.$post(this.apiName.receive, {
          appid: appid,
          mobile: mobile,
          bonus: x,
          index: y,
        })
          .then((res) => {
            if (res.code == "0000") {
              this.userInformation.bonus =
                this.userInformation.bonus + Number(x);
              this.nodeSubscript = e;
              this.nodeList[e].recved = true
              setTimeout(() => {
                this.nodeList[e].stat = false;
                let arrTmp = this.nodeList.find(item => item.stat == true)
                if (arrTmp == undefined || arrTmp == null || arrTmp.length == 0) {
                  that.$get(that.apiName.indexList, {
                    //星球中的小兰点
                    appid: appid,
                    mobile: mobile,
                  }).then((res) => {
                    if (res.code == "0000") {
                      // console.log(res)
                      var timestamp = new Date().getTime();
                      var arr = [];

                      if (res.data == null || res.data.length == 0) {
                        if (!this.bigSwitch) {
                          this.figureShow = false;
                        } else {
                          this.figureShow = true;
                        }
                      }
                      res.data.forEach((item, index) => {
                        arr.push({
                          value: item.value,
                          timeStamp: item.timeStamp,
                          index: item.index,
                          className: that.classLsist[index],
                          stat: true,
                          endTiem: item.timeStamp - 12 * 60 * 60,
                          startTiem: Number(
                            Math.round(new Date().getTime() / 1000).toString()
                          ),
                          isAnimationStart: true,
                          recved: false,
                        });
                      });
                      // arr.reverse();
                      // console.log(arr)
                      that.nodeList = arr;
                    } else {
                      Toast.fail("加载失败");
                    }
                  });
                  // this.figureShow = true;
                }
              }, 400);
              this.isReceiving = false;
            } else {
              this.isReceiving = false;
              Toast.fail(res.msg);
            }
          })
          .catch((res) => {
            this.isReceiving = false;
            Toast.fail("网络错误");
          });
      }
    },
    dividends() {
      //分红跳转
      this.$router.replace("/Dividends");
    },
    contributeBut() {
      //贡献跳转
      this.$router.replace("/Contribution");
    },
    raidersCli() {
      //攻略跳转
      this.$router.replace("/Raiders?id=1");
    },
    suggestCli() {
      //攻略跳转
      this.$router.replace("/suggest?id=1");
    },
    home() {
      window.location = this.homeUrl;
    },
    dividendRankingData(e) {
      //分红排行
      // this.dividendRankingList = [];
      this.$get(this.apiName.dividendRanking, {
        //用户贡献列表
        appid: appid,
        mobile: mobile,
        type: e,
      }).then((res) => {
        if (res.code == "0000") {
          // console.log(res.data)
          this.dividendRankingList = res.data;
        } else {
          Toast.fail("加载失败");
        }
      });
    },
    toFinish(e) {
      // 首先判断如果是指标任务，是否已经完成
      if (e.isTarget == 1) {
        this.$get(this.apiName.targetTaskIsFinished, {
          //用户贡献列表
          appid: appid,
          mobile: mobile,
          taskId: e.taskId,
        }).then((res) => {
          if (res.code == "0000") {
            if (res.data) {
              Toast.fail("该任务已完成");
            } else {
              if (e.action == 36) {
                // 是查看攻略
                this.$router.replace("/raiders?id=1")
              }
              if (e.toUrl != null && e.toUrl != "") {
                window.location = e.toUrl;
              }
            }
          } else {
            Toast.fail("查询失败");
          }
        });
      } else {
        if (e.toUrl == null || e.toUrl == "") {
        } else {
          console.log(e.toUrl);
          window.location = e.toUrl;
        }
      }
    },
    closeNotice() {
      this.setLocalStoreItem("shutdown notice", "1");
    },
    addCustomeInfo(key,value){
      this.$post('/user/addCustomInfoCache', {
        // 添加缓存
        appid: appid,
        mobile: mobile,
        key: key,
        value: value
      })
    },
    getCustomInfo(key){
      return this.$get('/user/getCustomInfoCache', {
        // 获取缓存
        appid: appid,
        mobile: mobile,
        key: key
      })
    },
    setLocalStoreItem(key,value) {
      this.addCustomeInfo(key,value)
      localStorage.setItem(key,value)
    },
    async getLocalStoreItem(key){
      let val = localStorage.getItem(key);
      if(val){
        this.addCustomeInfo(key,val)
        return val;
      }
      let res = await this.getCustomInfo(key);
      if (res.code == "0000" && res.data) {
        return res.data;
      }
      return ""
    },
    removeLocalStoreItem(key){
      this.addCustomeInfo(key,"")
      localStorage.removeItem(key)
    }
  },
}

</script>

<style scoped>
.van-count-down {
  color: #8f8f8f !important;
}

.yjlq{
  /*padding: 0px 5px;*/
  width: 64px;
  height: 20px;
  line-height: 20px;
  background-color: #f7f7f7;
  text-align: center;
  border-radius: 10px;
  color: #a6a6a6;
  right: 18px;
  position: absolute;
  font-size: 12px;
}

.myTip {
  z-index: 9999;
  width: 180px;
  height: 42px;
  background-color: #efefef;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  /*box-shadow: 10px 10px 10px rgba(0,0,0,.5);*/
  /*-moz-box-shadow: 10px 10px 10px rgba(0,0,0,.5);*/
  /*-webkit-box-shadow: 10px 10px 10px rgba(0,0,0,.5);*/
}

.rate {
  font-size: 18px;
  font-weight: 600;
  color: #000;
}

.navigation {
  display: flex;
  align-items: center;
}

.title {
  width: 100%;
  height: 64px;
  text-align: center;
  line-height: 64px;
  font-size: 15px;
}

.logo {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-left: 16px;
}

.wrapColour {
  display: flex;
  padding-top: 12px;
  overflow: hidden;
}

.contentOutside {
  background: #f7f7f7;
  width: 100%;
  height: 100%;
}

.wrapCon {
  /*width: 45%;*/
  margin-left: 8px;
  text-align: right;
}

.wrap {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.dividends {
  /*color: #2f80ed;*/
}

.dividendsNum {
  font-size: 18px;
  font-family: FZCYJ;
}

.dividendsTxt {
  font-size: 16px;
  font-weight: bold;
}

.contribution {
  margin-top: 5px;
}

.contribution > span:nth-child(1) {
  font-size: 14px;
  font-weight: bold;
  font-family: FZCYJ;
}

.contribution > span:nth-child(2) {
  font-size: 16px;
  margin-left: 2px;
}

.raidersWrap {
  margin-right: 18px;
}

.raiders {
  width: 23px;
  height: 23px;
}

.home {
  width: 23px;
  height: 23px;
}

.PlanetWrap {
  padding-top: 30px;
  position: relative;
  height: 430px;
  /*padding-bottom: 20px;*/
  /*background: url("/static/images/meteor.png") no-repeat;*/
  /*background-size: 100% 100%;*/
}

.big-switch {
  height: 445px;
}

.statistic {
  /* width: 95%; */
  /* background: #ffffff; */
  margin: 15px auto 0 auto;
  position: relative;
  /* padding-top: 15px; */
}

.PlanetWrap .change {
  width: 21px;
  height: 18px;
  position: absolute;
  top: 32px;
  right: 18px;
  z-index: 9999
}

.statistic .change {
  width: 21px;
  height: 18px;
  position: absolute;
  top: 17px;
  right: 18px;
  z-index: 9999
}

.scoreData {
  width: 95%;
  margin: 10px auto 0 auto;
  background: #fff;
  padding: 15px;
  box-sizing: border-box;
}

.scoreData .data {
  margin-top: 10px;
  display: flex;
  justify-content: space-around;
}

.scoreData .data .detail {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.scoreData .data .detail .subtitle {
  font-size: 14px;
  color: #878787;
}

.scoreData .data .detail > div:last-child {
  color: #8f8f8f;
  margin-top: 10px;
}

.scoreData .gap {
  width: 1px;
  height: 30px;
  background: #8f8f8f;
}

.question-container {
  position: absolute;
  right: -20px;
  top: 2px;
}

.question {
  width: 20px;
  height: 20px;
}

.question1 {
  width: 20px;
  height: 20px;
  margin-left: 5px;
}

.tips {
  background: #fff;
  font-weight: normal;
  font-size: 14px;
  position: absolute;
  top: -50px;
  right: 20px;
  width: 200px;
  padding: 10px;
  box-sizing: border-box;
  /* height: 50px; */
  color: #000;
  font-weight: 500;
  border: 1px solid #000;
}

.meteorSvg {
  width: 100%;
  height: 450px;
  position: absolute;
  left: 0;
  top: 0;
}

.Planet {
  width: 280px;
  height: 280px;
  margin: 0 auto;
  display: block;
}

.PlanetFileWrap {
  width: 240px;
  height: 240px;
  position: absolute;
  left: 50%;
  top: 35%;
  border-radius: 50%;
  margin-left: -120px;
  margin-top: -120px;
}

.prompt {
  width: 210px;
  height: 50px;
  text-align: center;
  line-height: 20px;
  /*background: #ffffff;*/
  position: absolute;
  left: 50%;
  margin-left: -105px;
  /*bottom: 10px;*/
  top: -30px;
  /*border-radius: 8px;*/
  /*box-shadow: darkgrey 2px 2px 20px 1px;*/
  /*display: flex;*/
  /*align-items: end;*/
  /*justify-content: center;*/

}

.promptTxt {
  width: 100%;
  background: #ffffff;
  font-size: 12px;
  padding: 8px;
  border-radius: 8px;
  box-shadow: darkgrey 2px 2px 20px 1px;
  position: absolute;
  bottom: 0;
  left: 0;
}

.arrow {
  width: 23px;
  height: 23px;
  position: absolute;
  left: 90px;
  top: 42px;
}

/*小点定位模块*/
.planetModule {
  position: relative;
}

.fixedPoint {
  width: 20px;
  height: 20px;
  position: absolute;
}

.fixedPoint_a {
  left: 151px;
  top: 20px;
}

.fixedPoint_b {
  left: 179px;
  top: 57.5px;
}

.fixedPoint_c {
  left: 242px;
  top: 50.5px;
}

.fixedPoint_d {
  left: 142px;
  top: 101.5px;
}

.fixedPoint_e {
  left: 90px;
  top: 117px;
}

.fixedPoint_f {
  left: 250.8px;
  top: 124px;
}

.fixedPoint_g {
  left: 41.9px;
  top: 164px;
}

.fixedPoint_h {
  left: 310.1px;
  top: 173.8px;
}

.fixedPoint_i {
  left: 203.5px;
  top: 183.1px;
}

.fixedPoint_j {
  left: 142.5px;
  top: 208.6px;
}

.fixedPoint_k {
  left: 77px;
  top: 228px;
}

.fixedPoint_l {
  left: 211.3px;
  top: 229.8px;
}

/*动态光环*/
.dynamicHalo {
  width: 40px;
  height: 42px;
}

.dynamicHaloWrap {
  position: absolute;
}

.dynamicHaloWrap-float{
  animation: float 2s ease-in-out infinite;
}

@keyframes float {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0);
  }
}

.dynamicHaloWrap > p {
  margin-top: -15px;
  color: #878787;
  font-family: FZCYJ;
  font-weight: bold;
  font-size: 10px;
  margin-bottom: 15px;
  text-align: center;
  margin-left: -10px;
}

.dynamicHalo_a {
  left: 162px;
  top: -19px;
}

.dynamicHalo_b {
  left: 99px;
  top: 55px;
}

.dynamicHalo_c {
  left: 169px;
  top: 44.6px;
}

.dynamicHalo_d {
  left: 232px;
  top: 37.5px;
}

.dynamicHalo_e {
  left: 293px;
  top: 66px;
}

.dynamicHalo_f {
  left: 184px;
  top: 111px;
}

.dynamicHalo_g {
  left: 241px;
  top: 112px;
}

.dynamicHalo_h {
  left: 31.8px;
  top: 152px;
}

.dynamicHalo_i {
  left: 125px;
  top: 146px;
}

.dynamicHalo_j {
  left: 300px;
  top: 160px;
}

.dynamicHalo_k {
  left: 200px;
  top: 217px;
}

.dynamicHalo_l {
  left: 126.5px;
  top: 251px;
}

.dynamicHalo_m {
  left: 200px;
  top: 230px;
}

.count-down {
  height: 60px;
}

.statistics {
  /*margin-top: 30px;*/
  text-align: center;
}

.statistics_p2 {
  /*color: #2f80ed;*/
  margin-top: 6px;
  font-size: 14px;
  /*text-indent : 30px*/
}

.statistics_p1 {
  color: #878787;
  margin-bottom: 6px;
  font-size: 14px;
  /*text-indent : 30px;*/
}

.progressBar {
  width: 200px;
  margin: 0 auto;
  position: relative;
}

.ProgressBarBackground {
  width: 100%;
  height: 6px;
  /*background: #cfe0f5;*/
  border-radius: 3px;
  overflow: hidden;
}

.degreeOfCompletion {
  height: 6px;
  width: 100%;
  /*background: #2f80ed;*/
  border-radius: 3px;
  overflow: hidden;
}

.carryOut {
  position: absolute;
  left: 0;
  top: 0;
}

.carryOutImg {
  width: 20px;
  height: 20px;
  position: absolute;
  right: -10px;
  top: -6.5px;
  border-radius: 50%;
}

.carryOutImg > p {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -4px;
  margin-top: -4px;
}

.wave {
  width: 100%;
  height: 50px;
  overflow: hidden;
  /*margin-bottom: 10px;*/
}

.waves {
  width: 400px !important;
  height: 40px !important;
  float: left;
}

.tab {
  width: 200px;
  display: flex;
  margin: 0 auto;
  font-size: 20px;
  color: #878787;
  justify-content: space-between;
}

.on {
  color: #0d0d0d;
  font-weight: bold;
}

.on > div {
  content: "";
  /*设置内容为空*/
  width: 40px;
  height: 4px;
  /*高度为0*/
  display: block;
  /*将文本转为块级元素*/
  /*background: #2f80ed;*/
  margin: 8px auto;
}

.operatingWrap {
  /*margin-top: 16px;*/
  display: flex;
  flex-wrap: nowrap;
  /*overflow-x: scroll;*/
  overflow: hidden;
  /*margin-left: 15px;*/
  /*padding-right: 15px;*/
  width: 100%;
  /*margin: 0 auto;*/
}

.operatingList {
  padding: 5px 10px;
  display: flex;
  border-radius: 15px;
  background: #e8f2ff;
  float: left;
  color: #3788f6;
  /*margin-right: 24px;*/
  /*min-width: 170px;*/
  font-size: 14px;
  /*margin-bottom: 16px;*/
  margin: 0 24px 16px 0;
}

.operatingList {
  margin-left: 15px;
}

.operatingList > p {
  white-space: nowrap;
}

.operatingList > img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
  border-radius: 50%;
}

.ulsList {
  width: 95%;
  margin: 0 auto;
}

.dailyCheckIn {
  /*width: 100%;*/
  height: 80px;
  background: #ffffff;
  display: flex;
  align-items: center;
  padding: 0 5%;
  justify-content: space-between;
  /*margin-bottom: 16px;*/
}

.dailyCheckIn > p:nth-child(1) {
  color: #0d0d0d;
  font-size: 20px;
  font-weight: bold;
}

.dailyCheckIn > p:nth-child(2) {
  width: 72px;
  height: 32px;
  color: #ffffff;
  font-size: 16px;
  text-align: right;
  /*background: #2f80ed;*/
  border-radius: 16px;
  line-height: 32px;
}

.taskType {
  background: #ffffff;
  overflow: hidden;
  margin-bottom: 16px;
}

.taskType > h3 {
  font-size: 20px;
  margin: 24px 0 0 16px;
}

.ulsList_ > li {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebebeb;
  width: 90%;
  margin: 20px auto 0;
  padding-bottom: 15px;
  align-items: center;
}

.ulsList_ > li > div > p:nth-child(1) {
  font-size: 16px;
  margin-bottom: 5px;
}

.ulsList_ > li > div > p:nth-child(2) > span:nth-child(1) {
  /*color: #2f80ed;*/
}

.ulsList_ > li > div > p:nth-child(2) {
  font-size: 14px;
}

.ulsList_ > li > div > p:nth-child(2) > span:nth-child(2) {
  color: #878787;
}

.ulsList_ > li:last-child {
  border: none !important;
  /*margin-top: 12px;*/
}

.ulsList_ > li > p {
  width: 72px;
  height: 32px;
  /*color: #2f80ed;*/
  font-size: 16px;
  text-align: center;
  /*border: #2f80ed 1px solid;*/
  border-radius: 16px;
  line-height: 32px;
}

.bottom {
  margin: 24px auto;
  text-align: center;
  font-size: 12px;
  color: #878787;
  padding-bottom: 24px;
}

.bottom > div {
  /*width: 94px;*/
  height: 12px;
  margin-bottom: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom > div > img {
  margin-right: 10px;
}

.bottom > p{
  margin-top: 8px;
}

.statTab {
  width: 156px;
  margin: 16px auto 4px;
  display: flex;
  font-size: 12px;
  justify-content: space-between;
}

.statTab > p {
  width: 48px;
  height: 24px;
  text-align: center;
  line-height: 24px;
}

.statTabOn {
  width: 48px;
  height: 24px;
  /*color: #2f80ed;*/
  border-radius: 12px;
  /*background: #e4ecf7;*/
}

.rank {
  display: flex;
  width: 170px;
  margin: 0 auto 20px;
  justify-content: space-between;
  font-size: 14px;
  color: #878787;
}

.uls {
  width: 95%;
  margin: 0 auto 50px;
  background: #ffffff;
}

.rankingList {
  border-bottom: 1px solid #ebebeb;
}

.rankingList:last-child {
  border: none;
}

.rankingListCon {
  display: flex;
  padding: 20px 10px 10px 10px;
}

.rankingListCon > img {
  width: 48px;
  height: 48px;
  margin-right: 16px;
  border-radius: 50%;
}

.rankingListConTitle {
  width: 60%;
  /*margin-right: 55%;*/
}

.rankingListConTitle > h3 {
  margin-bottom: 10px;
}

.rankingListConTitle > P {
  color: #878787;
  font-size: 14px;
}

.rankingListConTitle_ > p:nth-child(1) {
  color: #2f80ed;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: right;
  font-family: FZCYJ;
}

.rankingListConTitle_ > p:nth-child(2) {
  color: #8f8f8f;
  font-size: 14px;
  text-align: right;
}

@keyframes trY {
  100% {
    transform: translateY(-1000px);
  }
}

.dots {
  /*transition: all 1s ease-in;*/
  /*transform: translateY(-1000px);*/
  animation: trY 1s ease-in ;
  animation-fill-mode: forwards;
}



.pop {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 999;
  margin-left: -25%;
}

.noData {
  width: 80px;
  color: #878787;
  font-size: 16px;
  margin: 30px auto 50px;
  text-align: center;
}

.noData > img {
  width: 59px;
  height: 59px;
  display: block;
  margin: 0 auto;
  margin-bottom: 5px;
}

.wrapImg {
  width: 100%;
  height: 60px;
  position: relative;
  overflow: hidden;
}

.wrapImg_ {
  width: 400px;
  height: 20px;
  /*position: absolute;*/
  /*left: 0;*/
  /*top: 18px;*/
  /*margin-left: -2px;*/

  /*animation-fill-mode:forwards;*/
}

.wrapImgTop {
  width: 2400px;
  /*display: flex;*/
  position: absolute;
  left: 0;
  top: 0;
  animation: move 25s linear infinite normal;
}

.wrapImgTops {
  width: 2400px;
  position: absolute;
  left: 0;
  top: 0;
  animation: moves 24s linear infinite normal;
}

.wrapImgTops_a {
  width: 2400px;
  position: absolute;
  left: 0;
  top: 0;
  animation: moves_ 23s linear infinite normal;
}

.wrapImgTops_b {
  width: 2400px;
  position: absolute;
  left: 0;
  top: 0;
  animation: movesa_ 22s linear infinite normal;
}

@keyframes move {
  0% {
    transform: translateX(0px);
  }

  100% {
    transform: translateX(-800px);
  }
}

@keyframes moves {
  0% {
    transform: translateX(0px);
  }

  100% {
    transform: translateX(-800px);
  }
}

@keyframes moves_ {
  0% {
    transform: translateX(0px);
  }

  100% {
    transform: translateX(-800px);
  }
}

@keyframes movesa_ {
  0% {
    transform: translateX(0px);
  }

  100% {
    transform: translateX(-800px);
  }
}

.ButOn {
  border-radius: 20px;
  padding: 4px 12px;
}

.ButFinishOn {
  color: #878787;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue